import React, { useState, useEffect, useCallback } from 'react';
import { Menu, X } from 'lucide-react';
import { navLinks } from '../mock';

const scrollToSection = (href) => {
  const id = href.replace('#', '');
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else if (href === '#home') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

const DesktopHeader = ({ onNavigate }) => (
  <div className="hidden lg:block">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[78px] flex items-center justify-center">
      <nav className="flex items-center gap-7 xl:gap-9">
        {navLinks.map((l) => (
          <button
            key={l.href}
            onClick={() => onNavigate(l.href)}
            className="text-[12px] tracking-[0.24em] text-white/90 hover:text-[#f6c878] transition-colors font-medium relative group"
          >
            {l.label}
            <span className="absolute -bottom-1.5 left-1/2 -translate-x-1/2 h-px w-0 bg-[#f6c878] group-hover:w-full transition-all duration-300" />
          </button>
        ))}
        <button
          onClick={() => onNavigate('#contact')}
          className="bg-[#e6396b] hover:bg-[#cf2a5b] text-white px-6 py-2.5 rounded-full text-[12px] tracking-[0.24em] font-semibold transition-all hover:scale-105 shadow-lg"
        >
          CONTACT US
        </button>
      </nav>
    </div>
  </div>
);

const MobileHeader = ({ open, onToggle, onNavigate }) => (
  <div className="lg:hidden">
    <div className="px-5 h-[72px] flex items-center justify-end">
      <button
        className="text-white p-2 -mr-2"
        onClick={onToggle}
        aria-label="Toggle menu"
      >
        {open ? <X size={28} /> : <Menu size={28} />}
      </button>
    </div>

    {open && (
      <div className="bg-[#0f0f0f]/98 backdrop-blur-md border-t border-white/10">
        <div className="px-6 py-6 flex flex-col gap-4">
          {navLinks.map((l) => (
            <button
              key={l.href}
              onClick={() => onNavigate(l.href)}
              className="text-left text-[13px] tracking-[0.24em] text-white/85 hover:text-[#f6c878] py-1"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => onNavigate('#contact')}
            className="bg-[#e6396b] hover:bg-[#cf2a5b] text-white px-6 py-3 rounded-full text-[12px] tracking-[0.24em] font-semibold w-fit mt-2"
          >
            CONTACT US
          </button>
        </div>
      </div>
    )}
  </div>
);

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 80);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const handleNavigate = useCallback((href) => {
    setMobileOpen(false);
    scrollToSection(href);
  }, []);

  const toggleMobile = useCallback(() => {
    setMobileOpen((v) => !v);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#0f0f0f]/95 backdrop-blur-md shadow-2xl'
          : 'bg-gradient-to-b from-black/40 via-black/15 to-transparent'
      }`}
    >
      <DesktopHeader onNavigate={handleNavigate} />
      <MobileHeader
        open={mobileOpen}
        onToggle={toggleMobile}
        onNavigate={handleNavigate}
      />
    </header>
  );
};

export default Header;
